export const FILE_VALIDATION_ERRORS = {
    oneOrMoreFilesNeeded: 'one-or-more-files-needed',
    exactlyOneFileNeeded: 'exactly-one-file-needed',
    fileSizeToLarge: 'file-size-to-large',
    fileWithWrongType: 'file-with-wrong-type'
}

export const FILE_ACCEPT_TYPES = {
    MIME_TYPES: 'MIME_TYPES',
    EXTENSIONS: 'EXTENSIONS'
}
